import './locales/register'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

const List = lazy(() => import('./components/List'))
const Detail = lazy(() => import('./components/Detail'))

const InvoiceModule: RouteObject = {
    path: 'invoices',
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: ':id',
            element: <Detail />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default InvoiceModule
